<template>
  <div class="modal-box">
    <div class="modal operation-unavailable-modal" @click.self="$emit('close-btn-click')">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <p>{{ message }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" @click="$emit('close-btn-click')">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 操作できない理由。押されたボタンごとに呼び出し側で決める
    message: { type: String, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;

  .operation-unavailable-modal {
    display: flex;
    overflow-y: auto;

    .modal-dialog {
      max-width: 100%;
      width: 700px;
      margin: auto;

      @media screen and (max-width: $break-point) {
        margin: auto 30px;
      }
    }

    // 見出しが無いぶん、本文の上下を広めに取る
    .modal-body {
      padding: 30px 15px;
      line-height: 1.5em;
    }

    .modal-content {
      box-shadow: none;
      z-index: 9997;
    }

    // フッターの区切り線は不要
    .modal-footer {
      display: flex;
      justify-content: center;
      border-top: none;
    }
  }
}
</style>
